import { render, staticRenderFns } from "./SearchTask.vue?vue&type=template&id=54a35823&scoped=true&"
import script from "./SearchTask.vue?vue&type=script&lang=js&"
export * from "./SearchTask.vue?vue&type=script&lang=js&"
import style0 from "./SearchTask.vue?vue&type=style&index=0&id=54a35823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a35823",
  null
  
)

export default component.exports